import { render } from "./admin-theme.vue?vue&type=template&id=8f9e9440"
import script from "./admin-theme.vue?vue&type=script&lang=js"
export * from "./admin-theme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__